var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticStyle:{"max-width":"900px"}},[_c('span',{staticClass:"text-h5 d-block mb-3"},[_vm._v("Impressum")]),_c('v-divider',{staticClass:"mb-3"}),_c('div',[_vm._v(" "+_vm._s(_vm.logic.impressum)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }